<app-header></app-header>
<router-outlet></router-outlet>
@defer (on idle) {
  <app-overlay></app-overlay>
  <app-footer></app-footer>
}
